import React from "react";
import { Box, Paper, Typography } from "@mui/material";

interface SectionCardProps {
  icon: React.ReactNode;
  title: string;
  children: React.ReactNode;
}

const SectionCard: React.FC<SectionCardProps> = ({ icon, title, children }) => (
  <Paper variant="outlined" sx={{ p: 3, borderRadius: 3 }}>
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2.5 }}>
      {icon}
      <Typography fontWeight={800}>{title}</Typography>
    </Box>
    {children}
  </Paper>
);

export default SectionCard;
